import generify from './generic'
import { user, conf } from '../../stores'

export const sessionsEvents = generify('sessions-service', 'events', 'event')

sessionsEvents.stats = (axis, opts) => {
  let { experienceId, experienceIds, siteId, siteIds, from, to } = opts

  from = from || new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString()
  to = to || new Date().toISOString()
  const baseUrls = []
  if (!siteIds && siteId) {
    siteIds = [siteId]
  }
  if ((!experienceIds || experienceIds.length === 0) && experienceId) {
    experienceIds = [experienceId]
  }
  if (experienceIds && experienceIds.length > 0) {
    experienceIds
      .filter(experienceId => !!experienceId)
      .forEach(experienceId => {
        baseUrls.push('/experiences/' + experienceId + '/events')
      })
  } else {
    if (siteIds) {
      siteIds.forEach(siteId => {
        baseUrls.push('/sites/' + siteId + '/events')
      })
    } else {
      baseUrls.push('/events')
    }
  }
  const promises = baseUrls.map(baseUrl => {
    return fetch(`${conf.API_URL}/sessions-service${baseUrl}?from=${from}&to=${to}&types=rating`, {
      headers: {
        Authorization: 'Bearer ' + user.token
      }
    })
      .then(res => res.json())
      .then(json => {
        if (json.code && json.msg) {
          throw new Error(json.msg)
        }
        return json
      })
  })
  return Promise.all(promises).then(events => {
    const allComments = []
    events.forEach(eventsForAnExp => {
      eventsForAnExp.forEach(event => {
        if (event.values?.comment) {
          const comment = {
            _id: event._id,
            createdAt: event.createdAt,
            experienceId: event.experienceId,
            sessionId: event.sessionId,
            siteId: event.siteId,
            comment: event.values?.comment,
            rating: event.values?.ratings
          }
          allComments.push(comment)
        }
      })
    })
    return allComments
  })
}
